"use strict";

var _classCallCheck = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _assertThisInitialized = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _createClass = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ImagePreview = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function tokenToURL(token) {
  if (token.type !== 'string') {
    return null;
  }

  var value = token.string.slice(1).slice(0, -1).trim();

  try {
    var location = window.location;
    return new URL(value, location.protocol + '//' + location.host);
  } catch (err) {
    return null;
  }
}

function isImageURL(url) {
  return /(bmp|gif|jpeg|jpg|png|svg)$/.test(url.pathname);
}

var ImagePreview = /*#__PURE__*/function (_react$default$Compon) {
  _inherits(ImagePreview, _react$default$Compon);

  var _super = _createSuper(ImagePreview);

  _createClass(ImagePreview, null, [{
    key: "shouldRender",
    value: function shouldRender(token) {
      var url = tokenToURL(token);
      return url ? isImageURL(url) : false;
    }
  }]);

  function ImagePreview(props) {
    var _this;

    _classCallCheck(this, ImagePreview);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "state", {
      width: null,
      height: null,
      src: null,
      mime: null
    });

    return _this;
  }

  _createClass(ImagePreview, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._updateMetadata();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this._updateMetadata();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var dims = null;

      if (this.state.width !== null && this.state.height !== null) {
        var dimensions = this.state.width + 'x' + this.state.height;

        if (this.state.mime !== null) {
          dimensions += ' ' + this.state.mime;
        }

        dims = _react.default.createElement("div", null, dimensions);
      }

      return _react.default.createElement("div", null, _react.default.createElement("img", {
        onLoad: function onLoad() {
          return _this2._updateMetadata();
        },
        ref: function ref(node) {
          _this2._node = node;
        },
        src: tokenToURL(this.props.token)
      }), dims);
    }
  }, {
    key: "_updateMetadata",
    value: function _updateMetadata() {
      var _this3 = this;

      if (!this._node) {
        return;
      }

      var width = this._node.naturalWidth;
      var height = this._node.naturalHeight;
      var src = this._node.src;

      if (src !== this.state.src) {
        this.setState({
          src: src
        });
        fetch(src, {
          method: 'HEAD'
        }).then(function (response) {
          _this3.setState({
            mime: response.headers.get('Content-Type')
          });
        });
      }

      if (width !== this.state.width || height !== this.state.height) {
        this.setState({
          height: height,
          width: width
        });
      }
    }
  }]);

  return ImagePreview;
}(_react.default.Component);

exports.ImagePreview = ImagePreview;

_defineProperty(ImagePreview, "propTypes", {
  token: _propTypes.default.any
});